export default "__VITE_PUBLIC_ASSET__c0710e26__"